import { BLUEPRINT_INPUT_MAX_LENGTH } from "@/features/blueprints/blueprintTypes";

export const QUICK_BLUEPRINT_TITLE_MAX = 120;
export const QUICK_BLUEPRINT_INPUT_MIN = 50;

export type QuickBlueprintFieldError = {
  field: "title" | "inputText";
  message: string;
};

/**
 * Validates the Quick Blueprint form. Returns the first field error found, or
 * null when the form is valid. Checks are ordered so the most user-actionable
 * error surfaces first: title length → input minimum → input maximum.
 */
export function validateQuickBlueprintForm(
  title: string,
  inputText: string,
): QuickBlueprintFieldError | null {
  if (title.length > QUICK_BLUEPRINT_TITLE_MAX) {
    return {
      field: "title",
      message: `Blueprint title must be ${QUICK_BLUEPRINT_TITLE_MAX} characters or fewer.`,
    };
  }

  const trimmedInput = inputText.trim();

  if (trimmedInput.length < QUICK_BLUEPRINT_INPUT_MIN) {
    return {
      field: "inputText",
      message: `Describe the app idea in at least ${QUICK_BLUEPRINT_INPUT_MIN} characters.`,
    };
  }

  if (inputText.length > BLUEPRINT_INPUT_MAX_LENGTH) {
    return {
      field: "inputText",
      message: `App idea must be ${BLUEPRINT_INPUT_MAX_LENGTH.toLocaleString()} characters or fewer.`,
    };
  }

  return null;
}
